import styled from 'styled-components';
import { Input } from './Input';

interface SearchInputProps {
  variant?: 'default' | 'modal';
}

export const SearchInput = styled(Input)<SearchInputProps>`
  ${props => props.variant === 'modal' && `
    width: calc(100% - 3rem);
    margin: 0 1.5rem 1rem 1.5rem;
  `}
  
  &::placeholder {
    color: #9ca3af;
  }
  
  // Add search icon styling if needed
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z'/%3e%3c/svg%3e");
  background-position: left 12px center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
  padding-left: 40px;
`;